'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = curry;

var _curryN = require('./curryN');

var _curryN2 = _interopRequireDefault(_curryN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a curried version of `operation`.
 *
 * @example
 * const toArray = curry((a, b, c) => [a, b, c]);
 * const toArrayWith1 = toArray(1);
 * toArrayWith1(2, 3) === [1, 2, 3];
 *
 * @param  {Function} operation
 * @return {Function}
 */
function curry(operation) {
  return (0, _curryN2.default)(operation.length, operation);
}
module.exports = exports['default'];